export enum NavGroupType {
  Dashboards = 'Dashboards',
  Workspace = 'Workspace',
  Management = 'Management',
  Processing = 'Processing',
}

export enum NavItemName {
  Reports = 'Reports',
  Productivity = 'Productivity',
  PlanVsActual = 'Plan Vs Actual',
  Workspace = '3D Map',
  Projects = 'Projects',
  SwipeMap2D = '2D Swipe Map',
  SwipeMap3D = '3D Swipe Map',
  AccessTags = 'Access Tags',
  Users = 'Users',
  UserGroups = 'User Groups',
  Processing = 'Processing',
  OrganisationSettings = 'Organisation Settings',
}
